import { useEffect } from 'react'
import { globalEventsRegistry } from 'app/shared/ui/GlobalEvents/store/globalEventsRegistry'

export const useEventRegisterFull = () => {
  useEffect(() => {
    globalEventsRegistry.registerFullEvents()
    return () => globalEventsRegistry.unregisterFullEvents()
  }, [])
}
